import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class FacePressuresForcesAtAngleModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (FacePressuresForcesAtAngleModel._instance == null) FacePressuresForcesAtAngleModel._instance = new FacePressuresForcesAtAngleModel(authManager);
        return FacePressuresForcesAtAngleModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'face-pressures/face-pressures-forces-at-angles');

        this.entityName = 'face-pressures.FacePressuresForcesAtAngle';
        this.privileges = {
            create: [["#admin"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'J S Zeta Result';
        this.setLabel = 'J S Zeta Results';

        this.browser = {
            name: 'default-face-pressures-facepressuresforcesatangle-browser',
            moduleName: 'default-face-pressures-facepressuresforcesatangle-browser',
            moduleTitle: 'J S Zeta Results',
            moduleStateSlotName: 'default-face-pressures-facepressuresforcesatangle-browser',
        };

        this.editor = {
            name: 'default-face-pressures-facepressuresforcesatangle-editor',
            moduleName: 'default-face-pressures-facepressuresforcesatangle-editor',
            moduleTitle: 'J S Zeta Result',
            moduleStateSlotName: 'default-face-pressures-facepressuresforcesatangle-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'uid',
                type: 'string',
                persistent: true,
                label: 'Unique ID',
                required: true,
                readOnly: true,
            },
            {
                name: 'calculationId',
                type: 'FacePressuresCalculation',
                persistent: true,
                label: 'Calculation',
            },
            {
                name: 'wedgeSlidingAngleZeta',
                type: 'float',
                persistent: true,
                unit: 'deg',
                label: 'Wedge Sliding Angle Zeta',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'rectangularAreaRequiredSupportEarthForceEre',
                type: 'float',
                persistent: true,
                unit: 'kN',
                label: 'Rectangular Area Required Support Earth Force Ere',
                description: 'Ere',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'slidingWedgeWeightG',
                type: 'float',
                persistent: true,
                unit: 'kN',
                label: 'Sliding Wedge Weight G',
                description: 'G',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'verticalLoadFromSolidPrismPv',
                type: 'float',
                persistent: true,
                unit: 'kN',
                label: 'Vertical Load From Solid Prism Pv',
                description: 'Pv',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'verticalSlipSurfaceShearForceFromCohesionTc',
                type: 'float',
                persistent: true,
                unit: 'kN',
                label: 'Vertical Slip Surface Shear Force From Cohesion Tc',
                description: 'Tc',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'verticalSlipSurfaceShearForceFromFrictionTr',
                type: 'float',
                persistent: true,
                unit: 'kN',
                label: 'Vertical Slip Surface Shear Force From Friction Tr',
                description: 'Tr',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'verticalSlipSurfaceShearForceFromFrictionCohesionT',
                type: 'float',
                persistent: true,
                unit: 'kN',
                label: 'Vertical Slip Surface Shear Force From Friction Cohesion T',
                description: 'T',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
        ];

    }

}
